import { render, staticRenderFns } from "./OverdueChart.vue?vue&type=template&id=36959552"
import script from "./OverdueChart.vue?vue&type=script&lang=js"
export * from "./OverdueChart.vue?vue&type=script&lang=js"
import style0 from "./OverdueChart.vue?vue&type=style&index=0&id=36959552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports